import React from 'react';

const TermsOfService = () => {
	return (
		<div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#0f0c29] via-[#302b63] to-[#24243e] text-white px-4">
			<section className="max-w-[1000px] w-full my-24 px-6 sm:px-10 py-16 rounded-2xl bg-white/10 border border-white/20 shadow-[0_8px_30px_rgba(0,0,0,0.5)] backdrop-blur">
				<h1 className="text-4xl sm:text-5xl font-extrabold mb-10 text-center bg-gradient-to-r from-yellow-400 via-blue-600 to-purple-600 bg-clip-text text-transparent drop-shadow">
					Terms of Service
				</h1>

				<div className="space-y-10">
					<div>
						<h2 className="text-2xl font-bold mb-3 text-blue-400">1. Terms for Users/Clients</h2>
						<ul className="list-disc list-inside space-y-2 text-white/90 leading-relaxed">
							<li>Quotations are estimates and may change based on final requirements.</li>
							<li>Services are delivered as per the agreed scope, timeline, and payment terms.</li>
							<li>Support and maintenance are provided as per the selected plan.</li>
							<li>At least 25% advance to be paid. Max can be 50% of the total bill once the quote is confirmed.</li>
							<li>Once the MVP is submitted we only accept minor changes, not major ones.</li>
							<li>If any extra page or screen is requested upon the quotation generated, we will be charging per page (Extra Pages).</li>
							<li>Disputes are resolved under the jurisdiction of our registered location.</li>
						</ul>
					</div>

					<div>
						<h2 className="text-2xl font-bold mb-3 text-purple-400">2. Terms for Investors</h2>
						<ul className="list-disc list-inside space-y-2 text-white/90 leading-relaxed">
							<li>Investments are subject to due diligence, risk assessment, and regulatory compliance.</li>
							<li>Returns, reporting, and disclosures are managed transparently.</li>
							<li>Investor relations are governed by signed agreements and applicable laws.</li>
						</ul>
					</div>

					<div>
						<h2 className="text-2xl font-bold mb-3 text-green-400">3. Terms for Partners</h2>
						<ul className="list-disc list-inside space-y-2 text-white/90 leading-relaxed">
							<li>Partnerships are governed by mutual agreements outlining roles, responsibilities, and deliverables.</li>
							<li>Confidentiality and non-disclosure terms apply to all shared information.</li>
							<li>Disputes are resolved through negotiation or legal channels as specified in agreements.</li>
						</ul>
					</div>

					<div>
						<h2 className="text-2xl font-bold mb-3 text-pink-400">4. Terms for Students/Interns</h2>
						<ul className="list-disc list-inside space-y-2 text-white/90 leading-relaxed">
							<li>Internship offers are subject to eligibility and program requirements.</li>
							<li>Interns must comply with company policies and confidentiality agreements.</li>
							<li>Completion certificates and recommendations are provided based on performance.</li>
							<li>Payment/Stipend will depend on the project type and the work carried by the intern.</li>
						</ul>
					</div>

					<div>
						<h2 className="text-2xl font-bold mb-3 text-red-400">5. Terms for Employees</h2>
						<ul className="list-disc list-inside space-y-2 text-white/90 leading-relaxed">
							<li>Employment is governed by signed contracts, company policies, and labor laws.</li>
							<li>Employees must adhere to code of conduct, confidentiality, and performance standards.</li>
							<li>Termination, benefits, and grievance procedures are outlined in HR policies.</li>
						</ul>
					</div>

					<div>
						<h2 className="text-2xl font-bold mb-3 text-orange-300">Payments &amp; Refunds</h2>
						<ul className="list-disc list-inside space-y-2 text-white/90 leading-relaxed">
							<li>If the advance is paid, only 1 whole day will be available to cancel the project. If cancelled within 1 day, all the advance paid will be refunded.</li>
							<li>If the project is started and you cancel it, only 25% of the advance will be returned.</li>
							<li>If the front end is completed and you cancel the project, no amount will be refunded.</li>
							<li>If the project is near to its completion (85% complete) and you cancel it, you will have to pay a fine of 10% of the total bill as an extra with 50% advance.</li>
							<li>If the project is cancelled and no NDA, etc. has been signed, then the project, code, etc. belongs to MASRIQ NextTech Solutions.</li>
						</ul>
					</div>

					<div>
						<h2 className="text-2xl font-bold mb-3 text-yellow-300">General Terms</h2>
						<ul className="list-disc list-inside space-y-2 text-white/90 leading-relaxed">
							<li>By using our services, investing, partnering, or joining as an intern/employee, you agree to these terms.</li>
							<li>
								For questions, contact{' '}
								<a className="text-blue-200 underline" href="mailto:info@masriq.tech">info@masriq.tech</a>.
							</li>
						</ul>
					</div>
				</div>

				<p className="mt-10 text-center text-white/90">
					For full details, please contact us at{' '}
					<a className="text-blue-200 underline" href="mailto:info@masriq.tech">info@masriq.tech</a>.
				</p>
			</section>
		</div>
	);
};

export default TermsOfService;
